export enum TABS {
  MovePayment = 'move-payment-tab',
  EditPayment = 'edit-payment-tab',
}
